// src/api/authApi.js
import api from './axios';

export const login = (credentials) => api.post('/login', credentials);
export const register = (userData) => api.post('/register', userData);
export const logout = () => api.post('/logout');
export const getProfile = () => api.get('/profile');
export const verify2FA = (data) => api.post('/2fa/verify', data);
export const get2FAStatus = () => api.get('/2fa/status');
export const enable2FA = () => api.post('/2fa/enable');
export const confirm2FA = (code) => api.post('/2fa/confirm', { code });
export const disable2FA = (code) => api.post('/2fa/disable', { code });
export const regenerateRecoveryCodes = () => api.post('/2fa/recovery-codes');
